var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPythonLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 113,
    viewBox: "0 0 112 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.5102 0.397953C50.9265 0.419251 46.5492 0.810171 42.6977 1.4917C31.3514 3.49621 29.2914 7.6918 29.2914 15.4292V25.648H56.1039V29.0542H29.2914H19.2289C11.4364 29.0542 4.61315 33.7379 2.4789 42.648C0.017085 52.8609 -0.0921103 59.234 2.4789 69.8979C4.38483 77.8358 8.93645 83.4917 16.7289 83.4917H25.9477V71.2417C25.9477 62.3918 33.6048 54.5855 42.6977 54.5855H69.4789C76.9339 54.5855 82.8852 48.4473 82.8852 40.9605V15.4292C82.8852 8.16286 76.7552 2.70443 69.4789 1.4917C64.8729 0.724978 60.0938 0.376655 55.5102 0.397953ZM41.0102 8.6167C43.7797 8.6167 46.0414 10.9153 46.0414 13.7417C46.0414 16.558 43.7797 18.8355 41.0102 18.8355C38.2307 18.8355 35.9789 16.558 35.9789 13.7417C35.9789 10.9153 38.2307 8.6167 41.0102 8.6167Z",
    fill: "url(#paint0_linear_101_165)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2289 29.0542V40.9604C86.2289 50.1912 78.403 57.9604 69.4789 57.9604H42.6976C35.3618 57.9604 29.2914 64.2389 29.2914 71.5854V97.1167C29.2914 104.383 35.61 108.657 42.6976 110.742C51.185 113.237 59.3239 113.688 69.4789 110.742C76.229 108.787 82.8851 104.854 82.8851 97.1167V86.8979H56.1039V83.4917H82.8851H96.2914C104.084 83.4917 106.988 78.0563 109.698 69.8979C112.497 61.4991 112.378 53.4222 109.698 42.6479C107.772 34.8905 104.094 29.0542 96.2914 29.0542H86.2289ZM71.1664 93.7104C73.9459 93.7105 76.1976 95.9879 76.1976 98.8042C76.1976 101.631 73.9459 103.929 71.1664 103.929C68.3968 103.929 66.1351 101.631 66.1351 98.8042C66.1351 95.9879 68.3968 93.7104 71.1664 93.7104Z",
    fill: "url(#paint1_linear_101_165)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_101_165",
    x1: 0.59137,
    y1: 0.397034,
    x2: 62.4181,
    y2: 53.0819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A9FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#306998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_101_165",
    x1: 70.522,
    y1: 97.9451,
    x2: 48.341,
    y2: 66.8628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD43B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE873"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPythonLogo);
export default __webpack_public_path__ + "static/media/python-logo.c9bcff43b36e3d80fc18ede023065cf5.svg";
export { ForwardRef as ReactComponent };